export type Mode = "dark" | "light";

export interface MockTokens {
  bg: string; surface: string; surface2: string; border: string;
  text: string; textDim: string; textMute: string;
  accent: string; accentDeep: string; accentInk: string;
  coral: string; yellow: string; ok: string;
}

const DARK: MockTokens = {
  bg: "#0E1114", surface: "#161A1F", surface2: "#1F242B",
  border: "rgba(255,255,255,0.08)",
  text: "#F4F5F3", textDim: "rgba(244,245,243,0.62)", textMute: "rgba(244,245,243,0.40)",
  accent: "#B5A0FF", accentDeep: "#8B6FFF", accentInk: "#0E1114",
  coral: "#FF7A59", yellow: "#FFD84D", ok: "#7AE582",
};

const LIGHT: MockTokens = {
  bg: "#F4EFE6", surface: "#FBF7EC", surface2: "#EEE7D8",
  border: "rgba(20,19,17,0.10)",
  text: "#141311", textDim: "rgba(20,19,17,0.62)", textMute: "rgba(20,19,17,0.42)",
  accent: "#6C4DFF", accentDeep: "#4F34D6", accentInk: "#FFFFFF",
  coral: "#E8542F", yellow: "#F2B500", ok: "#2F9A60",
};

export const tokens = (mode: Mode): MockTokens => (mode === "light" ? LIGHT : DARK);

export const fonts = {
  display: "'Instrument Serif', Georgia, serif",
  ui: "Geist, -apple-system, BlinkMacSystemFont, sans-serif",
};
